import axios from "axios";
import React from "react";
import { useNavigate } from 'react-router-dom';
import SglContext from "../SglContext";
import indicator_icon from "../images/Indicator.gif";
import Pusher from 'pusher-js';
import Select from "react-select";
import './classSignups.css'
import { useSearchParams } from "react-router-dom";




// const sgl_webservice_class_signups_index = Sgl.sglApiUrl+'/iphonev2/classsignupv2/';
// const user_info_url = Sgl.nestApiUrl+'/users/getLoggedInUser';

// sgl_show_id = (sgl_show_id && sgl_show_id != '')?sgl_show_id:localStorage.getItem('show_id');


class ClassSignupIndex extends React.Component{
    
get sgl_webservice_class_signups_index() {
  return this.context.sglApiUrl + '/iphonev2/classsignupv2/';
}

get user_info_url() {
  return this.context.nestApiUrl + '/users/getLoggedInUser';
}

 sgl_show_id = (this.sgl_show_id && this.sgl_show_id != '')?this.sgl_show_id:localStorage.getItem('show_id');
    
 page_url ="//" +window.location.host  + window.location.pathname +window.location.search;

    state = {
        // channel: {},
        // class_group: {},
        
        signup_data: [],
        schedule_breaks: [],
        success: false,
        channel: '',
        signup_expires_in: 2,
        group_date: '',
        group_name: '',
        popup_data: [],
        selected_entryxclass: 0,
        top_error: '',
        time: {},
        seconds: 2*60,
        endTime: Date(),
        can_class_signup: true,

        current_show: this.sgl_show_id,
        userData: {},
        signupForUser: 0,
        loading:true
    }
    constructor() {
        super();
        this.ShowPickerElement = React.createRef();
        // bind function in constructor instead of render
        this.onShowChange = this.onShowChange.bind(this);
        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
    }
    componentDidMount() {
        document.title = "Class Signups";
        this.getSignupDetails();
        this.setListenPusher();
    }
    setListenPusher(){
        const self = this;
                var pusher = new Pusher('b6232310f51498462640');
                var channel = pusher.subscribe(this.sgl_show_id+this.context.company_id+this.getQueryVariable('cgid'));
                // var channel = $show_id . $customer_id . $class_group_id;

                channel.bind('rowupdate', function(grid_data) {
                    self.updateGridData(JSON.parse(grid_data));
                
                });
    }
    
    getSignupDetails(){
        this.getUserData();
        axios.all([
            axios.get(this.sgl_webservice_class_signups_index+'Index',{
                params : {
                    cgid: this.getQueryVariable('cgid'),
                    show_id: this.sgl_show_id,
                    customer_id: this.context.company_id,
                    team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
                }
                })
            ]).then(axios.spread((res) => {
                // reportToGA('/sgl-wp-plugin/'+company_path+'/'+sgl_show_id+'/classsignupdetail');
                if(res.data.success){
                    let expire_seconds = (res.data.signup_expires_in ? res.data.signup_expires_in * 60: 2*60);
                    let timeLeftVar = this.secondsToTime(expire_seconds);

                    this.setState({
                        success: res.data.success,
                        channel: res.data.channel,
                        signup_expires_in: res.data.signup_expires_in? res.data.signup_expires_in:2,
                        group_date: res.data.group_date,
                        group_name: res.data.group_name,
                        popup_data: res.data.popup_data,
                        can_class_signup: res.data.can_class_signup,
                        signup_data: res.data.class_data,
                        schedule_breaks: res.data.schedule_breaks,
                        time: timeLeftVar,
                        seconds: expire_seconds,
                        loading:false,
                    })
                } else {
                    if(res.data == 'DoLogin'){
                        this.context.checkLoginOnSGL();
                    } else {
                    // pop error messages
                        // window.location.href=this.page_url;
                    }
                    
                }
            }))
    }
    callReserveSignup(slot_id){
        axios.get(this.sgl_webservice_class_signups_index+'ReserveSignup',{
          params : {
            from_wp_api: true,
            slot_id: slot_id,
            show_id: this.sgl_show_id,
            customer_id: this.context.company_id,
            team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
          }
        }).then(res => {
            document.getElementById('reserve_checkbox_'+slot_id).style.display = "table-cell";
            document.getElementById('reserve_wait_'+slot_id).style.display = "none";
            if(res.data.success){

            } else {
                if(res.data == 'DoLogin'){
                    this.context.checkLoginOnSGL();
                } else {
                // pop error messages
                    window.alert(res.data.error);
                }
            }
        })
    }
    callCancelSignup(slot_id){
        axios.get(this.sgl_webservice_class_signups_index+'CancelSignup',{
          params : {
            from_wp_api: true,
            slot_id: slot_id,
            show_id: this.sgl_show_id,
            customer_id: this.context.company_id,
            team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
          }
        }).then(res => {
            document.getElementById('reserve_checkbox_'+slot_id).style.display = "table-cell";
            document.getElementById('reserve_wait_'+slot_id).style.display = "none";
            if(res.data.success){
            // this.updateGridData(res.data.grid_data);
                this.setState({ selected_entryxclass: 0 })
            } else {
                if(res.data == 'DoLogin'){
                    this.context.checkLoginOnSGL();
                } else {
                // pop error messages
                    window.alert(res.data.error);
                }
            }
        })
    }
    callSaveSignup(slot_id, entryxclass_id){
        if(entryxclass_id == 0){
            window.alert('Please select an Entry from the list');
        } else {
            axios.get(this.sgl_webservice_class_signups_index+'SaveSignup',{
            params : {
                from_wp_api: true,
                slot_id: slot_id,
                entryxclass_id: entryxclass_id,
                show_id: this.sgl_show_id,
                customer_id: this.context.company_id,
                team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
            }
            }).then(res => {
                if(res.data.success){
                    this.setState({ 
                        selected_entryxclass: 0
                    })
                    // this.updateGridData(res.data.grid_data);
                } else {
                    if(res.data == 'DoLogin'){
                        this.context.checkLoginOnSGL();
                    } else {
                    // pop error messages
                        window.alert(res.data.error);
                    }    
                    
                }
            })
        }
    }

    callCheckSignupExpire(){
        axios.get(this.sgl_webservice_class_signups_index+'CheckClassSignUpsExpire',{
          params : {
            from_wp_api: true,
          }
        }).then(res => {
        //   if(res.data.success){
        //     // this.updateGridData(res.data.grid_data);
        //   } else {
        //     // pop error messages
        //   }
        })
    }


    getUserData(){
        axios.get(this.user_info_url)
        .then((response) => {
            this.context.checkLoginOnSGL();
          if(response.data.user && response.data.user != null){
            this.setState({
              userData : response.data.user,
            });

            //get current team owner id
            if (this.context.currentTeamId != 'personal') {
                const selectedTeam = this.context.userTeams?.find(team => team.teamId == this.context.currentTeamId);
                this.setState({
                    signupForUser : selectedTeam.teamOwnerId,
                });
            } else {
                this.setState({
                    signupForUser : response.data.user.sgl_id,
                });
            }
            

          }else{
          }
        }, (error) => {
        });
    }

    onShowChange(show_id) {
        localStorage.setItem('show_id', show_id);
        window.location.href=this.page_url;
    }

    ReserveSlot(e, class_data) {
        var signup_data_list = this.state.signup_data;
        
        document.getElementById('reserve_checkbox_'+class_data.sgl_id).style.display = "none";
        document.getElementById('reserve_wait_'+class_data.sgl_id).style.display = "table-cell";
        

        var checked = e.target.checked;
        var sgl_logins_id = this.state.signupForUser;
        if(checked){
            // call sign up api here
            this.callReserveSignup(class_data.sgl_id);
            
        } else {
            sgl_logins_id = '0';
            if (window.confirm('Are you sure you want to cancel this sign up?')) {
                // call cancel signup api here
                this.callCancelSignup(class_data.sgl_id);
            } else {
                document.getElementById('reserve_checkbox_'+class_data.sgl_id).style.display = "table-cell";
                document.getElementById('reserve_wait_'+class_data.sgl_id).style.display = "none";
            }
        }
    }

    updateGridData(grid_data){
        var signup_data_list = this.state.signup_data;
        signup_data_list.forEach((signup_data, signup_index) => {
            if(signup_data.sgl_id === grid_data.sgl_id) {
                signup_data_list[signup_index] = grid_data;
                this.setState({
                    signup_data: signup_data_list
                });
            }
        });
        if(this.getReservedSlots().length == 1 && grid_data.sgl_logins_id == this.state.signupForUser && grid_data.entryxclasses_id == ''){
            document.getElementById('time_out_msg').style.display = "block";
            document.getElementById('time_expire_msg').style.display = "none";

            this.startTimer();
        } else if (this.getReservedSlots().length == 0){
            document.getElementById('time_out_msg').style.display = "none";
            clearInterval(this.timer);
            this.timer = 0;
            this.setState({
                time: this.secondsToTime(this.state.signup_expires_in * 60),
                seconds: this.state.signup_expires_in * 60,
            });
        }
    }
    getReservedSlots(){
        var reserverd_slots = this.state.signup_data.filter(c => c.sgl_logins_id == this.state.signupForUser && c.entryxclasses_id == '');
        return reserverd_slots;
    }
    getSelectedSlots(){
        var selected_counter = 0;
        this.state.signup_data.forEach(element => {
            if(element.sgl_logins_id != 0 && !this.checkDisableStatus(element)){
                selected_counter++;
            }
            
        });
        return selected_counter;
        // checked={data.sgl_logins_id != "0"} 
        //                                         disabled={(data.sgl_logins_id != '0' && data.sgl_logins_id != this.state.signupForUser && this.checkRiderEntry(data)) || (is_reserved_all && data.sgl_logins_id != this.state.signupForUser)}
                                                
    }
    getIsAllReservedStatus(){
        if(this.state.popup_data.length == 0){
            return true;
        }
        var reserverd_slots = this.state.signup_data.filter(c => c.sgl_logins_id == this.state.signupForUser || (!this.checkRiderEntry(c) && c.sgl_logins_id != '0'));
        if(this.state.popup_data.length <= reserverd_slots.length){
            return true;
        }
        return false;
    }
    getTopError(){
        var reserverd_slots = this.state.signup_data.filter(c => c.sgl_logins_id == this.state.signupForUser);
        if(!this.state.can_class_signup){
            return 'You do not have permission to sign up for this Class';
        }
        if(this.state.popup_data.length == 0){
            return 'You have no trips in the Class';
        }
        if(this.state.popup_data.length <= this.getSelectedSlots()){
            return 'You have no additional trips in the Class';
        }
        return '';
    }
    getTimeoutMessage(){
        var timeout_msg = '';
        var reserverd_slots = this.state.signup_data.filter(c => c.sgl_logins_id == this.state.signupForUser && c.horse_name == 'Reserved');
        if(reserverd_slots.length > 0){
            timeout_msg = 'Please complete your signup within '+ this.state.signup_expires_in +' minute(s) in order to retain your selected position(s).';
            // timeout_msg += 
        }
        return timeout_msg;
    }
    secondsToTime(secs){
        let seconds = Math.floor((secs / 1000) % 60);
        let minutes = Math.floor((secs / (1000 * 60)) % 60);
        let hours = Math.floor((secs / (1000 * 60 * 60)) % 24);

        hours = hours.toString().padStart(2, '0');
        minutes = minutes.toString().padStart(2, '0');
        seconds = seconds.toString().padStart(2, '0');
    
        let obj = {
          "h": hours,
          "m": minutes,
          "s": seconds
        };
        return obj;
    }

    startTimer() {
        if (this.timer == 0 && this.state.signup_expires_in > 0) {
          let now = new Date()
          let endTime = new Date(now.getTime() + this.state.signup_expires_in * 60000 + 1000)
          this.setState({ endTime: endTime, time: this.secondsToTime(endTime - now) });
          this.countDownFirst(endTime);
          this.timer = setInterval(this.countDown, 1000);
        }
    }

    getPopupData(){
        var entryxclasses_ids = this.state.signup_data.map(entry => entry.entryxclasses_id);
        entryxclasses_ids = [...new Set(entryxclasses_ids)];
        entryxclasses_ids = entryxclasses_ids.filter(c => c != '');

        var filter_popup = this.state.popup_data.filter(c => !entryxclasses_ids.includes(c.entryxclasses_id));

        let popup_data = filter_popup.map(function(data, index){ // Set select label and value
            data.label = data.entry_number + ' - ' + data.horse + ' ' + data.count;
            data.value = data.entryxclasses_id;
            return data;
        })
        return popup_data;
    }
    
    countDown() {
        // Remove one second, set state so a re-render happens.
        let timeLeft = this.state.endTime - new Date();
        this.setState({
            time: this.secondsToTime(timeLeft),
        });
        // Check if we're at zero.
        if (timeLeft <= 1000) { 
            // call executeCheckClassSignUpsExpire api here
            this.callCheckSignupExpire();
            clearInterval(this.timer);
            this.timer = 0;
            document.getElementById('time_out_msg').style.display = "none";
            document.getElementById('time_expire_msg').style.display = "block";
            this.setState({
                time: this.secondsToTime(this.state.signup_expires_in * 60),
            });
        }
    }
    countDownFirst(endTime) {
        // Remove one second, set state so a re-render happens.
        let timeLeft = endTime - new Date();
        this.setState({
            time: this.secondsToTime(timeLeft),
        });
        // Check if we're at zero.
        if (timeLeft <= 1000) { 
            // call executeCheckClassSignUpsExpire api here
            this.callCheckSignupExpire();
            clearInterval(this.timer);
            this.timer = 0;
            document.getElementById('time_out_msg').style.display = "none";
            document.getElementById('time_expire_msg').style.display = "block";
            this.setState({
                time: this.secondsToTime(this.state.signup_expires_in * 60),
            });
        }
    }

    onSelectChange(option){
        this.setState({ selected_entryxclass: option.value });
    }


    getOption = ({ entry_number,horse,count,rider_name }) => (
        <div class="option-container" style={{color: '#88201b'}}>
                <div class="entry">
                    <b>{entry_number} - {horse} {count}</b>
                </div>
                <div class="rider">
                    {rider_name}
                </div>
            </div>
      );
    getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) {
            return pair[1];
          }
        }
        return false;
      }
    checkRiderEntry(data) {
        var rider_data = this.state.popup_data;
        for(var entrycount=0;entrycount<rider_data.length;entrycount++){
            if(rider_data[entrycount].entry_id == data.entry_id){
                return false;
            }
        }
        return true;
    }
    checkDisableStatus(data){
        let is_reserved_all = this.getIsAllReservedStatus();
        var nor_current_user_slot = data.sgl_logins_id != '0' && data.sgl_logins_id != this.state.signupForUser && this.checkRiderEntry(data);
        var disabled= (nor_current_user_slot) || (is_reserved_all && data.sgl_logins_id != this.state.signupForUser && this.checkRiderEntry(data));
        return disabled
    }
    getParamDate(date_value){
        if(date_value != '' && date_value != "0000-00-00"){
            date_value = date_value.split('T')[0];
            return '?date='+date_value;
        }
        return;
    }  

    render() {
        const loading = this.state.loading;
        let is_reserved_all = this.getIsAllReservedStatus();
        if(loading) {
          return null;
        }
        
        return(
            <div class="sgl-plugin section-to-print classSignupDetailsCss">
                <h2>Sign up for {this.state.group_name} </h2>
                <button class='button sgl-button' 
                    onClick={(e) => {
                        // e.preventDefault();
                        const { navigate } = this.props;
                        navigate("/orders-of-go-signups"+this.getParamDate(this.state.group_date));
                    }}
                >
                    Back to Listing View
                </button>
                {(this.getTopError() != '') &&
                    <div class='top_error'>
                        {this.getTopError()}
                    </div>
                }
                    <div id='time_out_msg' class='time_out_msg display_none'>
                        {this.getTimeoutMessage()}
                        <span class='time_left'>Time left: {this.state.time.m}:{this.state.time.s}</span>
                    </div>
                    <div id='time_expire_msg' class='top_error display_none'>
                        We're sorry but the maximum amount of time has elapsed. Please begin again by checking off the positions you would like.
                    </div>
                {/* { this.state.signup_data.length > 0 && */}
                    <div class="div-responsive">
                        <table class="table table-striped classes-table">
                            <thead class="classes-header">
                                <tr>
                                    <th colspan="8" class='link_color'>CLASS SIGN UP</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr class="sgl-primary-header">
                                <th nowrap="nowrap" class='center-align'></th>
                                <th nowrap="nowrap" class='center-align'>Order</th>
                                <th nowrap="nowrap" class='center-align'>Time</th>
                                <th nowrap="nowrap" class='center-align display_on_desktop'>Entry</th>
                                <th nowrap="nowrap" class='display_on_desktop max_width_200'>Horse</th>
                                <th nowrap="nowrap" class='display_on_desktop'>Rider</th>
                                <th nowrap="nowrap" class='display_on_desktop'>Trainer</th>
                                <th nowrap="nowrap" class='display_on_mobile'>Entry Details</th>

                            </tr>
                            {
                                this.state.signup_data.map((data,index) => { 
                                return(
                                    <>
                                    <tr key={index} className={this.getReservedSlots().findIndex(slot => slot.sgl_id == data.sgl_id) >= 0 ? 'reserved-entry' : ''}>
                                        <td class='center-align width_30'>
                                            <input type="checkbox" name="order_of_go" id={'reserve_checkbox_'+data.sgl_id}  
                                                checked={data.sgl_logins_id != "0"} 
                                                disabled={this.checkDisableStatus(data)}
                                                onChange={e => this.ReserveSlot(e, data)}
                                            />
                                            <span id={"reserve_wait_"+data.sgl_id} class='display_none'><img src={indicator_icon} /></span>

                                        </td>
                                        <td id="order_of_go" class='center-align width_70'>{data.order_of_go}<div class="display_pure_mobile estimated_time_mobile"></div></td>
                                        <td class='center-align' style={{'white-space': 'nowrap'}}>{data.estimated_time}</td>
                                        <td class='center-align display_on_desktop'>{data.entry_number}</td>
                                        <td class='display_on_desktop max_width_200'>
                                            {
                                                this.getReservedSlots().length > 0 && this.getReservedSlots()[0].sgl_id == data.sgl_id ?
                                                <div style={{position: 'relative'}}>
                                                    <Select
                                                        options = {this.getPopupData()}
                                                        selected = {this.state.selected_entryxclass}
                                                        onChange = {(option) => {this.onSelectChange(option)}}
                                                        // components = {this.getOption(data)}
                                                        formatOptionLabel={this.getOption}
                                                        // classes={{
                                                        //     selectValue: this.getOption
                                                        //     // selectArrow: 'my-custom-arrow'
                                                        //   }}
                                                        clearable = {false}
                                                        searchable = {false}
                                                        className = "entryxclasses-picker"
                                                    />
                                                    <div id="action-buttons">
                                                        <button id="save-button" class="action-button sgl-button" onClick={() => {
                                                            this.callSaveSignup(data.sgl_id, this.state.selected_entryxclass)
                                                        }}>Save</button>
                                                        {' '}
                                                        <button id="cancel-button" class="action-button sgl-button" onClick={() => {
                                                            if (window.confirm('Are you sure you want to cancel this sign up?')) {
                                                                this.callCancelSignup(data.sgl_id);
                                                            }
                                                        }}>Cancel</button>
                                                    </div>
                                                </div>
                                                :
                                                data.sgl_logins_id == '0'? '' : data.horse_name
                                            }
                                        </td>
                                        <td class='display_on_desktop'>{data.rider_name}</td>
                                        <td class='display_on_desktop'>{data.trainer_name}</td>
                                        <td class='display_on_mobile'>
                                            {
                                                this.getReservedSlots().length > 0 && this.getReservedSlots()[0].sgl_id == data.sgl_id ?
                                                <div style={{position: 'relative'}}>
                                                    <Select
                                                        options = {this.getPopupData()}
                                                        onChange = {(option) => {this.onSelectChange(option)}}
                                                        selected = {this.state.selected_entryxclass}
                                                        formatOptionLabel={this.getOption}
                                                        clearable = {false}
                                                        searchable = {false}
                                                        className = "entryxclasses-picker"

                                                    />
                                                    <div id="action-buttons">
                                                        <button id="save-button" class="action-button sgl-button" onClick={() => {
                                                            this.callSaveSignup(data.sgl_id, this.state.selected_entryxclass)
                                                        }}>Save</button>
                                                        {' '}
                                                        <button id="cancel-button" class="action-button sgl-button" onClick={() => {
                                                            if (window.confirm('Are you sure you want to cancel this sign up?')) {
                                                                this.callCancelSignup(data.sgl_id);
                                                            }
                                                        }}>Cancel</button>
                                                    </div>
                                                </div>
                                                :
                                                <div>
                                                    <div>{data.entry_number}{data.sgl_logins_id == '0'? '' : ' - ' + data.horse_name}</div>
                                                    <div>{data.rider_name}{data.trainer_name ? ' - ' + data.trainer_name : ''}</div>
                                                </div>
                                            }
                                        </td>

                                    </tr>
                                    {this.state.schedule_breaks.map((schedule_break,index) => { 
                                        return(
                                            (schedule_break.position == index + 1) &&
                                            <tr key={index}>
                                                <td class='center-align'>""</td>
                                                <td class='center-align'> - </td>
                                                <td class='center-align'>{schedule_break.duration +" mins"}</td>
                                                <td class='center-align'> - </td>
                                                <td>{schedule_break.title}</td>
                                                <td> - </td>
                                                <td> - </td>
        
                                            </tr>
                                            
                                        )
                                    })}
                                    </>
                                )
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                {/* } */}
            </div>
        )
    }
}
    
ClassSignupIndex.contextType=SglContext
// ReactDOM.render(<ClassSignupIndex />, document.getElementById("sgl-content-wrapper"));
// export default ClassSignupIndex
export default function(props) {
    const navigate = useNavigate();

    return <ClassSignupIndex {...props} navigate={navigate} />;
}
